import ParkingOld, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/parkingat/[friendlyUrl]';
import ParkingNew from '@pages/myapp2/parkingat/[friendlyUrl]';

import { GetServerSideProps } from 'next';
import { useEffect, useState } from 'react';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const ret = await hgetServerSideProps(ctx);
  return ret;
};

const Parking = (data) => {
  return <ParkingNew {...data} />;
};

Parking.layout = "DefaultLayoutNoCanonical"
export default Parking;
